import {
  UPLOAD_MEDIA_ALL_FAIL,
  UPLOAD_MEDIA_ALL_REQUEST,
  UPLOAD_MEDIA_ALL_SUCCESS,
  UPLOAD_MEDIA_FAIL,
  UPLOAD_MEDIA_REQUEST,
  UPLOAD_MEDIA_SUCCESS,
} from "../actions/media";

const initialState = {
  loadingMedia: false,
};

export default function common(state = initialState, action) {
  switch (action.type) {

    case UPLOAD_MEDIA_REQUEST:
    case UPLOAD_MEDIA_ALL_REQUEST:
      return {
        ...state,
        loadingMedia: true
      };
    case UPLOAD_MEDIA_FAIL:
    case UPLOAD_MEDIA_SUCCESS:
    case UPLOAD_MEDIA_ALL_FAIL:
    case UPLOAD_MEDIA_ALL_SUCCESS:
      return {
        ...state,
        loadingMedia: false
      };

    default:
      return state;
  }
}
